import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { CwsSection, CwsTabCrab, CwsTabItemCrab } from '../../cms-web-styleguide-exports'
import s from './Coupons.module.scss'

export default function CouponTabs({ activeTab, setActiveTab, showExpiredTab, tabCouponCount }) {
  const { t } = useTranslation()

  const getTagLabel = tabKey => {
    const count = tabCouponCount(tabKey)
    return count > 0 ? count : undefined
  }

  return (
    <CwsSection className="cws-mb-m" style={{ maxWidth: '100%' }} variant="div">
      <CwsTabCrab activeTab={activeTab} controllable onChange={setActiveTab} size="large">
        <CwsTabItemCrab
          className={s['override-cws-color']}
          id="unused"
          label={t('available.codes')}
          tagLabel={getTagLabel('unused')}
        />
        <CwsTabItemCrab
          className={s['override-cws-color']}
          id="used"
          label={t('used.codes')}
          tagLabel={getTagLabel('used')}
        />
        {showExpiredTab && (
          <CwsTabItemCrab
            className={s['override-cws-color']}
            id="expired"
            label={t('expired.codes')}
            tagLabel={getTagLabel('expired')}
          />
        )}
      </CwsTabCrab>
    </CwsSection>
  )
}

CouponTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  showExpiredTab: PropTypes.bool,
  tabCouponCount: PropTypes.func.isRequired
}
